<template>
  <span class='currency-container'>
    {{this.value}}
  </span>
</template>

<script>
import GlobalData from '@/helpers/global-data'
import {toCurrency} from '@/helpers/currency-helper'

export default {
  components: { GlobalData },
  props: {
    val: {
      type: [String, Number],
      required: true
    },
    currency: {
      type: [String],
      required: false,
      default: 'USD'
    }
  },
  computed: {
    value () {
      if (this.val !== null) {
        return toCurrency(parseFloat(this.val), this.currency)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .currency-container {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/components/general/currency.vue